<template>
  <transition :name="transition">
    <slot></slot>
  </transition>
</template>
<script>
export default {
  name: "lms-nav-slide",
  props: {
    transition: {
      type: String,
      default: "primarySlide",
    },
  },
};
</script>
<style lang="scss">
// Primary Fade (desktop)
.primaryFade-enter-active {
  opacity: 1;
  transition: opacity 0.1s;
}

.primaryFade-leave-active {
  opacity: 1;
  transition: opacity 0.1s 0.2s;
}

.primaryFade-enter,
.primaryFade-leave-to {
  opacity: 0;
}

// Primary Slide (mobile)
.primarySlide-enter-active,
.primarySlide-leave-active {
  right: 0;
  transition: right 0.3s ease-in-out;
}
.primarySlide-enter,
.primarySlide-leave-to {
  right: 88%;
}

// Secondary Drawer
.secondarySlide-enter-active,
.secondarySlide-leave-active {
  left: -88%;
  transition: left 0.3s ease-in-out 0.3s;
}
.secondarySlide-enter,
.secondarySlide-leave-to {
  left: 0;
}
</style>
